import { Component, Inject, OnInit } from '@angular/core';
import { CrudFunctionProp, CurdDataSetConfig, FormDataSetConfig, TitleType } from '@mri/types';
import { FormDataSetModule } from '@mri/app/modules';
import { GlobalPageService } from '../../';
import { ActivatedRoute } from '@angular/router';
import { CardComponent } from '../../../@theme/components/card/card.component';
import { AuthResourceService, ConfigResourceService, GenericResourceService } from '@mri/app/resources';
import { Observable, Subscription, tap } from 'rxjs';
import { getQueryParams } from '@mri/functions';

@Component({
  selector: 'app-crud-data-set-form',
  template: `
    @if (formConfig) {
      <app-card [showHeader]="false">
        <app-form-data-set [config]="formConfig" [elementId]="elementId"></app-form-data-set>
      </app-card>
    }
  `,
  imports: [
    FormDataSetModule,
    CardComponent
  ],
  standalone: true
})
export class CrudDataSetFormComponent implements OnInit {
  private _subscription = new Subscription();

  formConfig!: FormDataSetConfig;
  elementId?: string;

  constructor(
    @Inject('CRUD_DATA_FORM_CONFIG') private _config: CurdDataSetConfig,
    @Inject('CRUD_DATA_FORM_ACTION') private _action: string,
    private _globalPageSrv: GlobalPageService,
    private _genericSrv: GenericResourceService,
    private _configSrv: ConfigResourceService,
    private _authSrv: AuthResourceService,
    private _route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    const params = getQueryParams();
    if (this._action === 'edit') this.elementId = this._route.snapshot.paramMap.get('id') || '';

    this._subscription.add(
      this._authSrv.authFirst$
        .pipe(
          tap(auth => auth && this._initComponent({
            auth, genericSrcSrv: this._genericSrv,
            params, elementId: this.elementId, action: this._action,
            configSrcSrv: this._configSrv
          }))
        ).subscribe()
    );

  }

  private _initComponent(prop: CrudFunctionProp): void {
    const { form } = this._config;

    if (typeof form === 'function') {
      this._initComponentFunction(prop);
    } else if (form) {
      this._initFormConfig(form);
    }
  }

  private _initComponentFunction(prop: CrudFunctionProp): void {
    const { form } = this._config;
    if(typeof form !== 'function') return;

    const formResult = form(prop);

    if(formResult instanceof Observable) {
      formResult.subscribe(config => this._initFormConfig(config));
      return;
    }

    this._initFormConfig(formResult);

  }

  private _initFormConfig(formConfig: FormDataSetConfig): void {
    const { entityName, baseBreadcrumb, gatewayUrl } = this._config;
    const pageName = this._action === 'create' ? `Crear ${entityName}` : `Editar ${entityName}`;
    const title = this._action === 'create' ? 'Crear' : 'Editar';

    this._globalPageSrv.setTitle(formConfig.pageConfig?.title || pageName);

    const link = `${baseBreadcrumb}/${this._action === 'create' ? 'create' : this.elementId}`;

    const breadcrumb: Array<TitleType> = [
      {
        url: formConfig.listRedirectUrl || `${baseBreadcrumb}/list`,
        title: entityName,
        link: formConfig.listRedirectUrl || `${baseBreadcrumb}/list`,
        type: 'item'
      },
      {
        pageName,
        url: link,
        title,
        link,
        type: 'item'
      }
    ];

    this._globalPageSrv.setBreadcrumb(formConfig.pageConfig?.breadcrumb || breadcrumb);

    if (formConfig) this.formConfig = { ...formConfig, gatewayUrl };
  }


}
